import FormContainer from 'components/common/FormContainer'
import ActionButtons from 'components/common/ActionButtons'
import CustomSelect from '../../components/CustomSelect'
import MessageBox from '../../../../../components/common/MessageBox '
import { FormTitle } from 'components/common/FormTitle'

import useCustomSelectStep from './hook'
import './style.styl'

const CustomSelectStep = ({
  fireboltStep,
  partnerFormName,
  title,
  headingText,
  fieldSlug,
  message,
}) => {
  const {
    selectedOption,
    setSelectedOption,
    formatWebhookResult,
    handleGoBack,
    handleNext,
  } = useCustomSelectStep({ fireboltStep, fieldSlug })

  return (
    <FormContainer imageSrc="images/bb/ourocard-novo.png">
      <div className="bbourocard-custom-select-step__container">
        <FormTitle
          title={title}
          description={headingText}
          hasRequiredFieldWarning={false}
        />
        <CustomSelect
          items={formatWebhookResult()}
          onRadioClick={(e) => setSelectedOption(e.target.value)}
        />
        <div className="bbourocard-custom-select-step__container-info">
          <ActionButtons
            isStepValid={!!selectedOption}
            onGoBack={handleGoBack}
            onSubmit={handleNext}
          />
          {message && (
            <MessageBox>
              <strong>{message}</strong>
            </MessageBox>
          )}
        </div>
      </div>
    </FormContainer>
  )
}

export default CustomSelectStep
